/** The web release version, pinned to a corner of every page — booker site,
 *  manager dashboard, admin console and both sign-in screens alike. It sits
 *  outside the router so no layout can forget it. */
export function VersionBadge() {
  return (
    <span className="app-version" aria-label={`Version ${__APP_VERSION__}`}>
      {__APP_VERSION__}
    </span>
  );
}
